import {ESmsPricingType} from 'src/containers/TariffsCatalog';

import {EStatus, NONE_SUBSCRIPTION} from './definitions';

export default {
  title: 'Анкета регистрации канала',
  subject: 'Имя отправителя',
  subjectHint: 'Имя отправителя на латинице (от 3 до 11 символов, учитывайте регистр)',
  subjectFullHint:
    'Имя должно быть уникальным и точно идентифицировать вашу компанию.\n' +
    'Операторы могут одобрить или отказать в согласовании Имени. Наш менеджер может обратиться к вам за документами, которые помогут согласовать Имя (свидетельство на Товарный знак, домен, лицензионный договор или другие документы)',
  website: 'Сайт вашей компании',
  exampleMessage: 'Пример текста сообщения',
  name: 'Внутреннее название канала',
  nameHint: 'Будет отображаться в списке каналов edna Pulse и в отчетности',
  subscriptionByOperatorCode: 'Условия тарификации по операторам. Сводная <0>таблица тарифов</0>',
  subscriptionByOperatorCodeLabel: 'Для абонентов {{name}}',
  operatorRuDefault: 'Другие операторы России',
  operatorRuMegafon: 'Мегафон + Скартел (Yota)',
  subscriptionByOperatorCodeLabelRu: 'Для абонентов прочих операторов России',
  subscriptionByOperatorCodeLabelRuHint:
    'Миранда\n' +
    'Ростелеком\n' +
    'МТТ\n' +
    'ВТБ Мобайл\n' +
    'ТрансТелеКом\n' +
    'ТатТелеком\n' +
    'Альфа-Мобайл\n' +
    'ГПБ Мобайл\n' +
    'Глобал телеком\n' +
    'Тинькофф и другие',
  clientComment: 'Комментарий',
  countries: 'Условия отправки сообщений для абонентов других стран',
  addCountry: 'Добавить страну',
  countrySubscription: 'Фиксированная цена за сообщение от клиентского имени',
  addCountryModal: {
    title: 'Добавить страну для отправки SMS',
    selectCountry: 'Выберите страну',
    submitButton: 'Добавить страну',
  },
  viewForm: {
    subscriptions: 'Условия отправки для этого отправителя',
    countries: 'Условия отправки сообщений для абонентов других стран',
    subscriptionsNoTariff: 'Российские операторы',
    countriesNoTariff: 'Другие страны',
  },
  status: {
    [EStatus.DRAFT]: 'Черновик',
    [EStatus.CREATE_SUBJECT]: 'Создание отправителя',
    [EStatus.CREATE_SUBJECT_ERROR]: 'Ошибка создания отправителя',
    [EStatus.IN_PROGRESS]: 'На регистрации',
    [EStatus.REJECTED]: 'Отключен',
    [EStatus.DONE]: 'Работает исправно',
  },
  pricingType: 'Тип тарификации:',
  setupConditions: 'Настроить условия',
  excludeOperator: 'Исключить оператора',
  pricingConditions: 'Условия тарификации',
  excludedPricingType: 'Не тарифицируется',
  excludedDescription:
    'Оператор отключен. На номера этого оператора сообщения отправляться не будут.',
  operatorStatus: {
    CONFIGURED: 'Настроен',
    EXCLUDED: 'Исключен',
    NOT_CONFIGURED: 'Не настроен',
  },
  errors: {
    operatorNotConfigured: 'Настройте условия тарификации или исключите оператора',
  },
  excludeOperatorModal: {
    title: 'Исключить оператора?',
    subtitle:
      'Если исключить оператора, сообщения не будут отправляться абонентам с номерами этого оператора',
    submitButton: 'Отключить',
  },
  options: {
    [ESmsPricingType.MAU]: 'Операторская тарификация',
    [ESmsPricingType.MULTI_MAU]: 'Мультиподпись',
    [ESmsPricingType.FEE]:
      'Абонентская плата за клиентское имя и цена за сообщение согласно прайсу',
    [ESmsPricingType.MULTI]: 'Фиксированная цена за сообщение от клиентского имени',
    [ESmsPricingType.COMMON]: 'Фиксированная цена за сообщение от общего имени',
    [ESmsPricingType.FEE_FIX]:
      'Абонентская плата за клиентское имя и фиксированная цена за сообщение',
    [NONE_SUBSCRIPTION]: 'Не подключать',
  },
  optionHints: {
    [ESmsPricingType.MAU]:
      'Сообщения отправляются от имени, которое вы ввели в этой анкете. Абонентская плата списывается ежемесячно, независимо от отправки SMS. Цена сообщений рассчитывается согласно тарифу.',
    [ESmsPricingType.MULTI_MAU]:
      'Сообщения отправляются от имени, которое вы ввели в этой анкете. Абонентская плата списывается ежемесячно, независимо от отправки SMS. Цена сообщений рассчитывается согласно тарифу.',
    [ESmsPricingType.FEE]:
      'Сообщения отправляются от имени, которое вы ввели в этой анкете. Абонентская плата списывается ежемесячно, независимо от отправки SMS. Цена сообщений рассчитывается согласно тарифу.',
    [ESmsPricingType.FEE_FIX]:
      'Сообщения отправляются от имени, которое вы указали выше. Абонентская плата списывается каждый месяц. Цена за каждое SMS фиксированная и не зависит от количества отправленных сообщений.',
    [ESmsPricingType.COMMON]:
      'Сообщения отправляются от Общего имени, а не от Имени которое вы указали выше. Абонентской платы за Имя нет. Цена за каждое SMS фиксированная и не зависит от количества отправленных сообщений.',
    [ESmsPricingType.MULTI]:
      'Сообщения отправляются от имени, которое вы указали выше. Абонентской платы за Имя нет. Цена за каждое SMS фиксированная и не зависит от количества отправленных сообщений.',
    [NONE_SUBSCRIPTION]:
      'Отправка сообщений на номера этого оператора будет невозможна. При попытке рассылки на такие номера плата взиматься не будет',
  },
  subscriptionsMessage: `Для регистрации канала заполните эту форму.<br/>Набор операторов и детали подключения вы можете уточнить у вашего менеджера`,
  registrationMessage: `Анкета этого СМС-канала отправлена на регистрацию. При изменении статуса вы получите уведомление по электронной почте`,
  channelDisabled: `Канал был отключен на стороне оператора. При возникновении вопросов обратитесь в службу технической поддержки.`,
};
